import { render } from "./HSChart.vue?vue&type=template&id=247b09e0&scoped=true"
import script from "./HSChart.vue?vue&type=script&lang=js"
export * from "./HSChart.vue?vue&type=script&lang=js"

import "./HSChart.vue?vue&type=style&index=0&id=247b09e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247b09e0"]])

export default __exports__